// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"c50e07fa","756":"1056fb0a"}[chunkId] + ".chunk.css";
};